// React imports.
import React from "react";

import { Assessment3StepsEnum } from "../state";
import { Assessment3VendorAssignedStatusEnum } from "../state";


const Assessment3Questions = ({fuelType, state }) => (
    <div>
        {(fuelType.vendorAssignmentStatus == Assessment3VendorAssignedStatusEnum.Under95NotMeetTarget
            ||fuelType.viewAnyway === true)
        &&
        <ol>
            <li>
                Does your LIHEAP application include main heating type?
                <br/>
                <label>
                    <input type="radio"
                        name="appIncludesMainHeatingTypeFlag"
                        id="appIncludesMainHeatingTypeFlag_true"
                        value="true"
                        checked={fuelType.appIncludesMainHeatingTypeFlag === true}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="appIncludesMainHeatingTypeFlag"
                        id="appIncludesMainHeatingTypeFlag_false"
                        value="false"
                        checked={fuelType.appIncludesMainHeatingTypeFlag === false}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.appIncludesMainHeatingTypeFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.appIncludesMainHeatingTypeFlag === false
                  && <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Having a section for fuel type on the LIHEAP
                        application can make it much easier to match accounts later on. Grant Recipients should ensure
                        that their LIHEAP application includes a section for heating fuel type.  Please describe your
                        plans to address this issue in the box below.
                        <br/>
                        <textarea  name="appIncludesMainHeatingTypeDesc"
                              id="appIncludesMainHeatingTypeDesc" style={{width:"100%"}}
                              value={fuelType.appIncludesMainHeatingTypeDesc}
                              onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                        <br/>
                    </span>}
                <br/>  
            </li>
            <li>
                Does the application include vendor name and account number for {fuelType.descriptionHeat}? <br/>
                <label>
                    <input type="radio"
                        name="appIncludesVendorAndAcctNumFlag"
                        id="appIncludesVendorAndAcctNumFlag_true"
                        value="true"
                        checked={fuelType.appIncludesVendorAndAcctNumFlag === true}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="appIncludesVendorAndAcctNumFlag"
                        id="appIncludesVendorAndAcctNumFlag_false"
                        value="false"
                        checked={fuelType.appIncludesVendorAndAcctNumFlag === false}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.appIncludesVendorAndAcctNumFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.appIncludesVendorAndAcctNumFlag === false
                  && <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Grant Recipients are required to have 12 months of
                        consecutive billing data main heating fuel in order to report those expenditure
                        numbers on their LIHEAP Performance Data Form. All Grant Recipients need to ensure that their
                        client applications require clients to include their account number with their
                        main heating vendor.  Please describe your plans to address this issue in the box below.
                        <br/>
                        <textarea  name="appIncludesVendorAndAcctNumDesc"
                              id="appIncludesVendorAndAcctNumDesc" style={{width:"100%"}}
                              value={fuelType.appIncludesVendorAndAcctNumDesc}
                              onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                        <br/>
                    </span>}
                <br/>
            </li>
            <li>
                Does the application include a client waiver allowing for data exchanges? <br/>
                <label>
                    <input type="radio"
                        name="appIncludesClientWaiverFlag"
                        id="appIncludesClientWaiverFlag_true"
                        value="true"
                        checked={fuelType.appIncludesClientWaiverFlag === true}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="appIncludesClientWaiverFlag"
                        id="appIncludesClientWaiverFlag_false"
                        value="false"
                        checked={fuelType.appIncludesClientWaiverFlag === false}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.appIncludesClientWaiverFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.appIncludesClientWaiverFlag === false
                  && <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Without client waivers, vendors may not be
                        willing to furnish data for LIHEAP clients to protect their
                        privacy and security. Grant Recipients should ensure that all of their
                        LIHEAP applicants sign a waiver allowing for the transfer of
                        data from fuel vendors to the state LIHEAP office.   Please
                        describe your plans to address this issue in the box below.
                        <br/>
                        <textarea  name="appIncludesClientWaiverDesc"
                              id="appIncludesClientWaiverDesc" style={{width:"100%"}}
                              value={fuelType.appIncludesClientWaiverDesc}
                              onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                        <br/>
                    </span>
                }
                <br/>
            </li>


            <li>
                Can you think of any other issues that may be impacting your vendor assignment rate?<br/>
                <label>
                    <input type="radio"
                        name="anyOtherIssuesAssignmentRateFlag"
                        id="anyOtherIssuesAssignmentRateFlag_true"
                        value="true"
                        checked={fuelType.anyOtherIssuesAssignmentRateFlag === true}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="anyOtherIssuesAssignmentRateFlag"
                        id="anyOtherIssuesAssignmentRateFlag_false"
                        value="false"
                        checked={fuelType.anyOtherIssuesAssignmentRateFlag === false}
                        onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.anyOtherIssuesAssignmentRateFlag === false
                  && <span><strong>No action needed</strong></span>}
                {fuelType.anyOtherIssuesAssignmentRateFlag === true
                  && <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Please describe that issue in the response box below, then indicate any plans or ideas
                        that you may have to address that issue. 
                        <br/>
                        <textarea  name="anyOtherIssuesAssignmentRateDesc"
                              id="anyOtherIssuesAssignmentRateDesc" style={{width:"100%"}}
                              value={fuelType.anyOtherIssuesAssignmentRateDesc}
                              onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                        <br/>
                    </span>
                }
            </li>

        </ol>
        }
    </div>
);

export default Assessment3Questions;
